import { WELLNESS_SUB_DOMAINS_DISPLAY_LABELS } from '@/constants';
import { THealthSubDomain } from '@/types/Health.types';
import { TTeamConcernCategory, TTeamConcernsRange } from '@/types/Organization.types';

export const COLLAPSED_TOP_COUNT = 6;
export const BAR_HEIGHT = 20;
export const ROW_GAP = 10;
export const MIN_SEGMENT_PX = 32;

export const RANGE_DISPLAY_LABELS: Record<TTeamConcernsRange, string> = {
  'last-month': 'Last month',
  'last-3-months': 'Last 3 months',
  'last-6-months': 'Last 6 months',
  'last-year': 'Last year',
  'all-time': 'All time',
};

export type StackedRow = TTeamConcernCategory & { isOther?: boolean };

export const formatSubdomainLabel = (category: string) =>
  WELLNESS_SUB_DOMAINS_DISPLAY_LABELS[category as THealthSubDomain] ?? category;

export const buildCollapsedRows = (categories: TTeamConcernCategory[]): StackedRow[] => {
  if (categories.length <= COLLAPSED_TOP_COUNT) return categories;

  const top = categories.slice(0, COLLAPSED_TOP_COUNT - 1);
  const rest = categories.slice(COLLAPSED_TOP_COUNT - 1);

  const otherRow: StackedRow = {
    category: 'OTHER_CONCERNS' as THealthSubDomain,
    domain: rest[0]?.domain ?? 'MENTAL',
    peerSupportCount: rest.reduce((sum, c) => sum + c.peerSupportCount, 0),
    screenerCount: rest.reduce((sum, c) => sum + c.screenerCount, 0),
    total: rest.reduce((sum, c) => sum + c.total, 0),
    isOther: true,
  };

  return [...top, otherRow];
};
